/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { useGoodsWatchlist } from "features/watchlist/useWatchlist";

import type { FcWithoutChildren } from "types/fcWithoutChildren";

type Props = {
  itemId: string;
};

export const WatchListButton: FcWithoutChildren<Props> = (props) => {
  const { itemId } = props;

  const { goodsWatchlist, toggleWatchlist } = useGoodsWatchlist([itemId]);

  const isWatched =
    goodsWatchlist?.find((item) => {
      const { eventGoodsFirestoreId, isInWatchlist } = item;
      return isInWatchlist && eventGoodsFirestoreId === itemId;
    }) !== undefined;

  // TODO: 多言語対応
  const buttonLabel = isWatched ? "さくじょ" : "ついか";
  const handleClick = () => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    toggleWatchlist(itemId);
  };

  return (
    <button css={rootStyle} onClick={handleClick}>
      {/* TODO: 多言語対応 */}
      ウォッチ{buttonLabel}
    </button>
  );
};

const rootStyle = css`
  background-color: white;
  border: 1px solid black;
  color: black;
`;
